
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzPageList from "@/models/MiezzPageList";
import DtoPageListSearchCompanyContact from "@/models.machine/DtoPageListSearchCompanyContact";
import DtoListItemCompanyContact from "@/models.machine/DtoListItemCompanyContact";
import CompanyContactPageList from "@/views/Company/CompanyContact/CompanyContactPageList.vue";
@Options({
  components: {
    CompanyContactPageList,
  },
})
export default class CustomerServiceProviderCompanyContactPageList extends Vue {
  /**分页列表 */
  list = new MiezzPageList<
    DtoPageListSearchCompanyContact,
    DtoListItemCompanyContact,
    string
  >("CustomerManagement_ServiceProvider_Contact");

  created(): void {
    //列表-顶部按钮
    this.list.TopButtons = [
      {
        Code: "add",
        Label: "添加",
        Icon: "plus",
        Type: "primary",
        Size: "small",
        PowerCode: "CustomerManagement_ServiceProvider_Contact_Add",
      },
    ];
    //列表-行按钮
    this.list.RowButtons = [
      {
        Code: "detail",
        Title: "查看详细",
        Icon: "search",
        Type: "default",
        Size: "small",
        PowerCode: "CustomerManagement_ServiceProvider_Contact_Detail",
      },
    ];
    //列表-底部按钮
    this.list.BottomButtons = [
      {
        Code: "batch-delete",
        Label: "删除",
        Icon: "delete",
        Type: "text",
        Message: "是否确认删除",
        PowerCode: "CustomerManagement_ServiceProvider_Contact_Delete",
      },
    ];
  }
}
